import { NgModule } from '@angular/core';
import { PershingCoreModule } from '@pershing/pershing-core';
import { NxiWidgetParamsService } from '../services/NXI-WidgetParams.service';
import { DojoManageUserHeaderComponent } from '../components/ManagerUserHeader/dojo-manage-user-header.component';

@NgModule({
    imports: [PershingCoreModule],
    declarations: [DojoManageUserHeaderComponent],
    exports: [DojoManageUserHeaderComponent],
    providers: [ NxiWidgetParamsService]

})

export class MCVModule { }
